export default "__VITE_ASSET__f042a412__"